import { LocalePreferenceMap } from '../types';

export const LOCALE_PREFERENCES: LocalePreferenceMap = {
  'en-US': {
    s4pLocaleCode: 'en',
    languageCode: 'us',
    languageAndRegionCode: 'en-us',
    brandVideoUrl: 'https://www.youtube.com/embed/7BeKkcY5y4E',
  },
  en: {
    s4pLocaleCode: 'en',
    languageCode: 'us',
    languageAndRegionCode: 'en-us',
    brandVideoUrl: 'https://www.youtube.com/embed/7BeKkcY5y4E',
  },
  'es-MX': {
    s4pLocaleCode: 'es-MX',
    languageCode: 'mx',
    languageAndRegionCode: 'es-mx',
    brandVideoUrl: 'https://www.youtube.com/embed/DwD5BtxwIh8',
  },
  'pt-BR': {
    s4pLocaleCode: 'pt-BR',
    languageCode: 'br',
    languageAndRegionCode: 'pt-br',
    brandVideoUrl: 'https://www.youtube.com/embed/ilFC_ZSKfIU',
  },
};
export const PODCASTERS_ZENDESK_LINK = `https://support.spotifyforpodcasters.com/hc/`;
export const PODCAST_SUPPORT_EMAIL = 'podcaster-support@spotify.com';
export const DEFAULT_SPOTIFY_AGGREGATOR_ID = '6BJtNPLQSTx541yBr7HDFq';

export const CATEGORIES_KEY = 'categoriesState';
export const COUNTRIES_KEY = 'countriesState';
export const LANGUAGES_KEY = 'languagesState';
export const AGGREGATORS_KEY = 'aggregatorsState';

export const CURRENT_SPEC_PDF = `${window.location.origin}/terms/Spotify_Podcast_Delivery_Specification_v1.6.pdf`;

// We cannot programmatically use the current year because the campaigns go into the following year
export const WRAPPED_BANNERS_DISPLAY_YEAR = 2020;
